export const MODALIDADES = [
    { label: 'Adesão interna', value: 'Adesão interna'},
    { label: 'Adesão externa', value: 'Adesão externa'},
    { label: 'Sem licitação', value: 'Sem licitação' },
    { label: 'Convite', value: 'Convite' },
    { label: 'Credenciamento', value: 'Credenciamento' },
    { label: 'Tomada de preço', value: 'Tomada de preço' },
    { label: 'Concorrência', value: 'Concorrência' },
    { label: 'Concurso', value: 'Concurso' },
    { label: 'Pregão', value: 'Pregão' },
    { label: 'Leilão', value: 'Leilão' },
    { label: 'Inexigibilidade', value: 'Inexigibilidade' },
    { label: 'Dispensa de valor', value: 'Dispensa de valor' },
    { label: 'Dispensa emergencial', value: 'Dispensa emergencial' },
    { label: 'Dispensa por outros motivos', value: 'Dispensa por outros motivos' },
    { label: 'Pregão eletrônico', value: 'Pregão eletrônico' },
    { label: 'Pregão presencial', value: 'Pregão presencial' },
    { label: 'Adesão a registro de preço', value: 'Adesão a registro de preço' },
    { label: 'Chamada pública', value: 'Chamada pública' },
    { label: 'Regime Diferenciado de Contratação - RDC', value: 'Regime Diferenciado de Contratação - RDC' },
    { label: 'Termo de fomento', value: 'Termo de fomento' },
    { label: 'Dispensa de locação', value: 'Dispensa de locação' },
    { label: 'Dispensa Eletrônica', value: 'Dispensa Eletrônica' },
    { label: 'Concorrência Eletrônica', value: 'Concorrência Eletrônica' },
    { label: 'Dispensa Presencial', value: 'Dispensa Presencial' },
    { label: 'Diálogo Competitivo', value: 'Diálogo Competitivo' }
];



// WEBPACK FOOTER //
// ./src/app/_mocks/modalidades.ts